/*
  hannari 2026-07-31 / 商品画像 拡大表示(product-media-modal)の
  「画像だけのピンチズーム」実装。タッチ端末のみで動作する。

  背景（とも様 2026-07-31 実機報告）:
    素の状態ではモーダル内でピンチしてもブラウザの「ページ全体の拡大」が働き、
    ヘッダ・外部アプリのボタンごと拡大され、スワイプすると画像から離れてしまう。
    テーマにもDawnにも「画像だけを拡大する」機能は元から無い。

  本スクリプトの担当:
    - モーダル内は touch-action:none（CSS側）でブラウザのページ拡大を止め、
      ピンチ／パン／ダブルタップを自前で処理して画像だけに transform を当てる。
    - ページ自体は常に100%のまま。閉じれば状態はリセットされる。
    - 拡大表示中だけ、画面に重なる外部アプリのフローティング要素を
      visibility:hidden で伏せる（閉じたら復帰。display は触らないので
      ウィジェットの再初期化は起きない）。
    - 拡大したまま左右スワイプで前後の画像へ移動する（iOS写真アプリと同じ作法）。
      素の Dawn はモバイルだと拡大表示で1枚しか見られず、次の画像を拡大するのに
      「縮小→閉じる→ルーペ」で毎回3ステップかかっていた（20枚なら60ステップ超）。
      画像の端までパンしてさらに引っ張ると隣へ送る＝拡大したまま移動でき、
      閉じたときは最後に見ていた画像へギャラリー側も揃える。

  非タッチ環境（デスクトップ）では何もしない＝従来の挙動のまま。
*/
(function () {
  if (window.__hnnrModalZoom) return;
  window.__hnnrModalZoom = true;

  if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return;

  var MIN_SCALE = 1;          /* ピンチアウトで全体表示まで戻せる */
  var DEFAULT_SCALE = 1.5;    /* 開いた直後の既定倍率＝「拡大された」ことが一目で分かる */
  var MAX_SCALE = 6;
  var DOUBLE_TAP_SCALE = 3;
  var HINT_MS = 2600;         /* ピンチ可能を示すナッジの表示時間 */
  var HINT_KEY = 'hnnrZoomHinted';
  var SWIPE_EDGE_PX = 60;     /* 端でこれ以上引っ張ったら隣の画像へ */
  var EDGE_RUBBER = 0.3;      /* 端を越えた分の追従量（ゴムのような手応え） */
  var SLIDE_MS = 170;         /* 送り出し／入れ替えのスライド時間（片道） */
  var SKIP_TAGS = /^(SCRIPT|STYLE|LINK|NOSCRIPT|TEMPLATE|META|MAIN|HEADER|FOOTER)$/;

  /* ---------- ピンチ可能を示すナッジ（文字を使わない・多言語安全） ----------
     とも様指摘: ルーペを押したのに等倍のままだと「押せたのか」が分からない。
     文字トーストは多言語でレイアウトが崩れる危険があるため採用せず、
     指2本が開くピクトグラムだけを数秒出して自然に消す。
     一度でも自分でピンチできた人には以後出さない（sessionStorage）。 */
  function alreadyHinted() {
    try { return window.sessionStorage.getItem(HINT_KEY) === '1'; } catch (e) { return false; }
  }
  function markHinted() {
    try { window.sessionStorage.setItem(HINT_KEY, '1'); } catch (e) { /* private mode 等 */ }
  }
  function buildHint() {
    var el = document.createElement('div');
    el.className = 'hnnr-zoom-hint';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg viewBox="0 0 64 64" focusable="false">' +
      '<circle class="hnnr-zoom-hint__dot hnnr-zoom-hint__dot--a" cx="24" cy="24" r="6"/>' +
      '<circle class="hnnr-zoom-hint__dot hnnr-zoom-hint__dot--b" cx="40" cy="40" r="6"/>' +
      '<path class="hnnr-zoom-hint__ray hnnr-zoom-hint__ray--a" d="M18 30 L18 18 L30 18"/>' +
      '<path class="hnnr-zoom-hint__ray hnnr-zoom-hint__ray--b" d="M46 34 L46 46 L34 46"/>' +
      '</svg>';
    return el;
  }

  /* ---------- 拡大表示中に画面へ重なる外部要素を伏せる ---------- */
  function collectOverlays(modal) {
    var list = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === modal || el.contains(modal)) return;
      if (SKIP_TAGS.test(el.tagName)) return;
      if (el.hasAttribute('hidden')) return;
      if (el.classList && el.classList.contains('shopify-section')) return;
      if (el.id && el.id.indexOf('shopify-section') === 0) return;

      var fixed = false;
      try {
        if (window.getComputedStyle(el).position === 'fixed') {
          fixed = true;
        } else {
          var kids = el.querySelectorAll('*');
          for (var i = 0; i < kids.length && i < 60; i++) {
            if (window.getComputedStyle(kids[i]).position === 'fixed') { fixed = true; break; }
          }
        }
      } catch (e) { /* クロスオリジン等は触らない */ }

      if (fixed) list.push([el, el.style.visibility]);
    });
    return list;
  }

  function setup(modal) {
    if (modal.dataset.hnnrZoom) return;
    modal.dataset.hnnrZoom = '1';

    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    var img = null;
    var scale = 1, tx = 0, ty = 0;
    var sScale = 1, sTx = 0, sTy = 0, sDist = 0, sMidX = 0, sMidY = 0;
    var panX = 0, panY = 0, moved = false, mode = null;
    var lastTapAt = 0, lastTapX = 0, lastTapY = 0;
    var overlays = [];
    var hint = null, hintTimer = null, counter = null;
    var edgeOver = 0, lastDx = 0, lastDy = 0;

    function showHint() {
      if (alreadyHinted()) return;
      if (!hint) { hint = buildHint(); modal.appendChild(hint); }
      /* 次フレームで付けないと transition が走らない */
      window.requestAnimationFrame(function () { hint.classList.add('is-visible'); });
      window.clearTimeout(hintTimer);
      hintTimer = window.setTimeout(hideHint, HINT_MS);
    }

    function hideHint(learned) {
      window.clearTimeout(hintTimer);
      if (learned) markHinted();
      if (hint) hint.classList.remove('is-visible');
    }

    /* 画像アイテムだけを対象にする（動画・3Dモデルが active のときは null） */
    function mediaItems() {
      return Array.prototype.filter.call(content.children, function (el) {
        return el.hasAttribute && el.hasAttribute('data-media-id');
      });
    }

    function currentIndex(items) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('active')) return i;
      }
      return 0;
    }

    function activeImg() {
      var a = content.querySelector('.active');
      if (a && a.tagName === 'IMG') return a;
      return a ? null : content.querySelector('img');
    }

    /* 先読みは「次の1枚」だけに絞る。
       2000px級の画像は1枚あたり約16MBにデコードされるため、前後2枚を同時に持つと
       モバイルのメモリ上限に触れてタイルが破棄され、描画が縞状に崩れる（とも様実機で確認）。 */
    function preloadNext() {
      var items = mediaItems();
      var el = items[currentIndex(items) + 1];
      if (!el) return;
      var im = el.tagName === 'IMG' ? el : el.querySelector('img');
      if (im && im.getAttribute('loading') === 'lazy') im.setAttribute('loading', 'eager');
    }

    /* インラインの transform / opacity を全アイテムから消す。
       送った画像に古い transform が残ると、再表示時にズレた位置で描かれる。 */
    function clearAllTransforms() {
      mediaItems().forEach(function (el) {
        el.style.transform = '';
        el.style.transition = '';
        el.style.opacity = '';
        el.style.willChange = '';
      });
    }

    function reduceMotion() {
      try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
    }

    /* ジェスチャ中だけ合成レイヤーを確保する。
       常時 will-change を付けると大きな画像の裏バッファを持ち続けメモリを圧迫する。 */
    function lift(on) {
      if (!img) return;
      img.style.willChange = on ? 'transform' : '';
    }

    /* 何枚目かの表示。数字と "/" だけ＝翻訳不要・レイアウトも崩れない */
    function updateCounter() {
      var items = mediaItems();
      if (items.length < 2) { if (counter) counter.style.display = 'none'; return; }
      if (!counter) {
        counter = document.createElement('div');
        counter.className = 'hnnr-zoom-count';
        counter.setAttribute('aria-hidden', 'true');
        content.appendChild(counter);
      }
      counter.style.display = '';
      counter.textContent = (currentIndex(items) + 1) + ' / ' + items.length;
    }

    /* 隣の画像へ。端ならバウンスして戻すだけ。
       表示は「今の画像を送り出す → 入れ替える → 反対側から入れる」の2段スライド。
       同時に2枚を出すとflexのレイアウトが崩れるため、常に1枚だけを動かす。
       動かすのは合成済みの1要素の transform だけなので描画コストはほぼゼロ。 */
    var busy = false;

    function swapTo(out, inn) {
      out.classList.remove('active');
      inn.classList.add('active');
      updateCounter();
      preloadNext();
    }

    function go(dir) {
      if (busy) return;
      var items = mediaItems();
      var i = currentIndex(items);
      var n = i + dir;
      if (!items.length || n < 0 || n >= items.length) { clamp(); apply(); return; }

      var out = items[i], inn = items[n];
      var w = content.clientWidth || 320;

      if (reduceMotion() || !img) {
        clearAllTransforms();
        swapTo(out, inn);
        reset(true);
        return;
      }

      busy = true;
      var leaving = img;

      /* ① 今の画像を指の向きへ送り出す */
      leaving.style.transition = 'transform ' + SLIDE_MS + 'ms ease-out, opacity ' + SLIDE_MS + 'ms ease-out';
      tx += (dir > 0 ? -w : w);
      apply();
      leaving.style.opacity = '0';

      window.setTimeout(function () {
        leaving.style.transition = '';
        leaving.style.opacity = '';
        leaving.style.transform = '';
        leaving.style.willChange = '';
        swapTo(out, inn);

        var next = activeImg();
        if (!next) { busy = false; return; }

        /* ② 反対側から入れる */
        img = next;
        scale = DEFAULT_SCALE;
        ty = 0;
        tx = (dir > 0 ? w : -w);
        next.style.transition = '';
        next.style.opacity = '0';
        apply();

        window.requestAnimationFrame(function () {
          next.style.transition = 'transform ' + SLIDE_MS + 'ms ease-out, opacity ' + SLIDE_MS + 'ms ease-out';
          next.style.opacity = '1';
          tx = 0;
          clamp();
          apply();
          window.setTimeout(function () {
            next.style.transition = '';
            next.style.opacity = '';
            busy = false;
          }, SLIDE_MS + 40);
        });
      }, SLIDE_MS);
    }

    /* 閉じたとき、最後に見ていた画像にギャラリー側も揃える
       （閉じたら1枚目に戻る、という違和感を無くす） */
    function syncGallery() {
      try {
        var items = mediaItems();
        var cur = items[currentIndex(items)];
        if (!cur) return;
        var section = document.getElementById('shopify-section-' + modal.dataset.section);
        var gallery = section && section.querySelector('media-gallery');
        if (gallery && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(cur.getAttribute('data-media-id'), false);
        }
      } catch (e) { /* ギャラリー未実装のテンプレでも落とさない */ }
    }

    function apply() {
      if (img) img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }

    function limits() {
      if (!img) return { x: 0, y: 0 };
      return {
        x: Math.max(0, (img.offsetWidth * scale - content.clientWidth) / 2),
        y: Math.max(0, (img.offsetHeight * scale - content.clientHeight) / 2)
      };
    }

    function clamp() {
      if (!img) return;
      var l = limits();
      tx = Math.min(l.x, Math.max(-l.x, tx));
      ty = Math.min(l.y, Math.max(-l.y, ty));
    }

    function center() {
      var r = content.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }

    /* 点 (px,py) を固定したまま倍率を next へ */
    function zoomAround(next, px, py, baseScale, baseTx, baseTy) {
      next = Math.min(MAX_SCALE, Math.max(MIN_SCALE, next));
      var c = center();
      var k = next / baseScale;
      tx = (px - c.x) * (1 - k) + baseTx * k;
      ty = (py - c.y) * (1 - k) + baseTy * k;
      scale = next;
      clamp();
      apply();
    }

    /* 開いた直後は DEFAULT_SCALE で表示する（等倍のままだと「拡大された」と分からない）。
       画像の読み込みが終わると実寸が確定するので、そこでもう一度クランプし直す。 */
    function reset(toDefault) {
      clearAllTransforms();
      img = activeImg();
      scale = toDefault ? DEFAULT_SCALE : 1;
      tx = 0; ty = 0;
      if (!img) return;
      if (!toDefault) { img.style.transform = ''; return; }
      clamp(); apply();
      if (!img.complete) {
        img.addEventListener('load', function onLoad() {
          img.removeEventListener('load', onLoad);
          clamp(); apply();
        });
      }
    }

    function dist(a, b) {
      return Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
    }

    content.addEventListener('touchstart', function (e) {
      if (busy) return;
      img = activeImg();
      if (!img) return;
      lift(true);

      if (e.touches.length >= 2) {
        hideHint(true);   /* 自分でピンチできた＝以後ナッジ不要 */
        mode = 'pinch';
        var t0 = e.touches[0], t1 = e.touches[1];
        sDist = dist(t0, t1);
        sMidX = (t0.clientX + t1.clientX) / 2;
        sMidY = (t0.clientY + t1.clientY) / 2;
        sScale = scale; sTx = tx; sTy = ty;
        e.preventDefault();
      } else {
        hideHint();
        mode = 'pan';
        panX = e.touches[0].clientX;
        panY = e.touches[0].clientY;
        sTx = tx; sTy = ty; moved = false;
      }
    }, { passive: false });

    content.addEventListener('touchmove', function (e) {
      if (!img) return;

      if (mode === 'pinch' && e.touches.length >= 2) {
        e.preventDefault();
        var d = dist(e.touches[0], e.touches[1]);
        if (sDist <= 0) return;
        zoomAround(sScale * (d / sDist), sMidX, sMidY, sScale, sTx, sTy);
        return;
      }

      if (mode === 'pan' && e.touches.length === 1) {
        var dx = e.touches[0].clientX - panX;
        var dy = e.touches[0].clientY - panY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
        e.preventDefault();
        lastDx = dx; lastDy = dy;

        var l = limits();
        var wantX = sTx + dx;
        edgeOver = 0;
        if (wantX > l.x) {
          edgeOver = wantX - l.x;            /* 右へ引っ張っている＝前の画像 */
          tx = l.x + edgeOver * EDGE_RUBBER;
        } else if (wantX < -l.x) {
          edgeOver = wantX + l.x;            /* 左へ引っ張っている＝次の画像 */
          tx = -l.x + edgeOver * EDGE_RUBBER;
        } else {
          tx = wantX;
        }
        ty = Math.min(l.y, Math.max(-l.y, sTy + dy));
        apply();
      }
    }, { passive: false });

    content.addEventListener('touchend', function (e) {
      if (e.touches.length === 1 && mode === 'pinch') {
        /* 2本指→1本指：そのままパンへ引き継ぐ */
        mode = 'pan';
        panX = e.touches[0].clientX;
        panY = e.touches[0].clientY;
        sTx = tx; sTy = ty; moved = true;
        return;
      }
      if (e.touches.length > 0) return;

      /* 端を越えて十分に引っ張った＋横方向が主 → 隣の画像へ */
      if (mode === 'pan' && moved) {
        if (Math.abs(edgeOver) >= SWIPE_EDGE_PX && Math.abs(lastDx) > Math.abs(lastDy)) {
          go(edgeOver < 0 ? 1 : -1);
        } else {
          clamp(); apply(); lift(false);
        }
        edgeOver = 0; mode = null;
        return;
      }
      lift(false);

      if (mode === 'pan' && !moved) {
        var t = e.changedTouches[0];
        var now = Date.now();
        if (now - lastTapAt < 300 &&
            Math.abs(t.clientX - lastTapX) < 30 &&
            Math.abs(t.clientY - lastTapY) < 30) {
          e.preventDefault();
          zoomAround(scale > DEFAULT_SCALE * 1.05 ? DEFAULT_SCALE : DOUBLE_TAP_SCALE, t.clientX, t.clientY, scale, tx, ty);
          hideHint(true);
          lastTapAt = 0;
        } else {
          lastTapAt = now; lastTapX = t.clientX; lastTapY = t.clientY;
        }
      }
      mode = null;
    }, { passive: false });

    /* モーダルの開閉に追随（開＝重なる要素を伏せる／閉＝復帰しリセット） */
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        overlays = collectOverlays(modal);
        overlays.forEach(function (p) { p[0].style.visibility = 'hidden'; });
        setTimeout(function () {
          reset(true);
          updateCounter();
          preloadNext();
          showHint();
        }, 0);
      } else {
        hideHint();
        syncGallery();
        overlays.forEach(function (p) { p[0].style.visibility = p[1] || ''; });
        overlays = [];
        reset(false);
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function scan() {
    document.querySelectorAll('product-modal.product-media-modal').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  /* product-modal は connectedCallback で body へ移動するため遅延再走査 */
  setTimeout(scan, 400);
  setTimeout(scan, 1500);
  document.addEventListener('shopify:section:load', scan);
})();
